import { ProductDetailComponent } from '../../components/product-detail';
import { useParams } from 'react-router';
import { Product } from '../../common/model';
import { useSelector } from 'react-redux';
import { ErrorState, RootState } from './../../redux/AppReducer';
import { FC, useEffect, useState } from 'react';
import { GET_PRODUCT } from '../../graphql/queries/product';
import { useQuery } from '@apollo/client';
import { validateImageArray } from '../../helpers/validateImagesCanLoad';
import { AppActions } from '../../redux/AppActions';
import { GENERAL_ERRORS, serverError } from '../../common/constants';
import { UserActions } from '../../redux/UserActions';
import { SearchActions } from '../../redux/search/SearchActions';
import { useAppDispatch } from '../../redux/store';
import { AuthActions } from '../../redux/AuthActions';

const ProductDetail: FC = () => {
	const { id } = useParams();
	const dispatch = useAppDispatch();
	const deviceScreen = useSelector((state: RootState) => state.appState?.deviceScreen);
	const currentEvent = useSelector(
		(state: RootState) => state.appState?.storeState?.getCurrentEvent
	);
	const [product, setProduct] = useState<Product | undefined>();
	const { data, loading, error } = useQuery<any>(GET_PRODUCT, {
		variables: { id, expoEventId: currentEvent?.id },
		skip: currentEvent === undefined
	});
	const [finishValidation, setFinishValidation] = useState(false);
	const tokenHasError = useSelector(
		({ appState: state }: RootState) => state.authState?.tokenHasError
	);

	const handleError = (error: ErrorState) => dispatch(AppActions.setGeneralError(error));
	const handleUnauthorized = () => dispatch(AppActions.unauthorizedError());
	const registerUserClickEvent = (event: string) =>
		dispatch(UserActions.registerUserClickEvent(event));

	const seHasClickedOutsideSearch = (clicked: boolean) =>
		dispatch(SearchActions.seHasClickedOutsideSearch(clicked));

	useEffect(() => {
		seHasClickedOutsideSearch(true);
		setTimeout(() => {
			seHasClickedOutsideSearch(false);
		}, 50);
	}, []);

	useEffect(() => {
		if (!error && !loading && data?.product) {
			const { __typename, ...rest } = data.product;
			setProduct(rest);
		}
		if (error?.message === 'Unauthorized') {
			if (tokenHasError === 0) {
				dispatch(AuthActions.setTokenError(1));
			}
		}
		if (error?.message === GENERAL_ERRORS.USER_TOKEN_EXPIRED) {
			handleUnauthorized();
		}
		if (error) {
			handleError(serverError);
		}
	}, [data, error, loading]);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	useEffect(() => {
		async function validateImages() {
			if (product && product.images && !finishValidation) {
				await validateImageArray(product.images).then(res => {
					setProduct({ ...product, images: res });
					setFinishValidation(true);
				});
			}
		}
		validateImages();
	}, [product, finishValidation]);

	if (loading || !finishValidation) {
		return null;
	}

	return (
		<ProductDetailComponent
			product={product}
			deviceScreen={deviceScreen}
			registerUserClickEvent={registerUserClickEvent}
		/>
	);
};

export default ProductDetail;
